import React from "react";
import PropTypes from "prop-types";
import "../../../NonRKPayInvoiceDetail.scss";

// Reusable ActionButton component
const ActionButton = ({ id, className, onClick, disabled, iconClass, label, title, isHidden, loading, dataTestId }) => {
    if (isHidden) return null;
    const { lang } = global;

    return (
        <button
            type="button"
            id={id}
            className={className}
            title={disabled ? lang.t("ToolbarDisabledAction") : title}
            onClick={onClick}
            disabled={disabled}
            loading={loading}
            data-test-id={dataTestId}
        >
            <span>
                {loading && <i className="rkf rkf-spinner rkf-spin rkf-fw" />}
                <span className={loading ? "hidden" : undefined}>
                    {iconClass && <i className={iconClass} />}
                    &nbsp;{label}
                </span>
            </span>
        </button>
    );
};

ActionButton.propTypes = {
    id: PropTypes.string.isRequired,
    className: PropTypes.string,
    onClick: PropTypes.func,
    disabled: PropTypes.bool,
    iconClass: PropTypes.string,
    label: PropTypes.string.isRequired,
    title: PropTypes.string,
    isHidden: PropTypes.bool,
    loading: PropTypes.bool,
    dataTestId: PropTypes.string,
};

ActionButton.defaultProps = {
    disabled: false,
    iconClass: null,
    isHidden: false,
    className: "btn text-left",
    onClick: () => {},
    title: "",
    loading: false,
    dataTestId: null,
};

export default ActionButton;
